import { createContext } from 'react'

export const VegaEditorContext = createContext( {} )
